"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchableText = function SearchableText(_ref) {
  var className = _ref.className,
      query = _ref.query,
      text = _ref.text;

  // only allow search queries of at least length 2
  if ((0, _isEmpty.default)(query) || (0, _isEmpty.default)(text) || query.length > text.length || query.length < 2) {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)(className)
    }, text);
  }

  var lowerText = text.toLowerCase();
  var lowerQuery = query.toLowerCase();
  var queryLength = query.length;
  var foundIndices = [];
  var foundIndex = lowerText.indexOf(lowerQuery, 0);

  while (foundIndex != -1) {
    foundIndices.push(foundIndex);
    foundIndex = lowerText.indexOf(lowerQuery, foundIndex + queryLength);
  }

  var tokens = [];
  var currentLocation = 0;
  (0, _forEach.default)(foundIndices, function (i) {
    tokens.push( /*#__PURE__*/_react.default.createElement("span", {
      key: currentLocation
    }, text.slice(currentLocation, i)));
    tokens.push( /*#__PURE__*/_react.default.createElement("span", {
      key: "match" + i,
      className: "match"
    }, text.slice(i, i + queryLength)));
    currentLocation = i + queryLength;
  });
  tokens.push( /*#__PURE__*/_react.default.createElement("span", {
    key: currentLocation
  }, text.slice(currentLocation)));
  return /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)("searchable", className)
  }, tokens.map(function (t) {
    return t;
  }));
};

SearchableText.propTypes = {
  query: _propTypes.default.string,
  text: _propTypes.default.string,
  className: _propTypes.default.string
};
var _default = SearchableText;
exports.default = _default;